export const locales = [
    {
        code: 'fr_FR',
        label: "Français (France)"
    },
    {
        code: 'en_US',
        label: "English (United States)"
    },
    {
        code: 'de_DE',
        label: "Deutsch (Deutschland)"
    },
    {
        code: 'es_ES',
        label: "Español (España)"
    },
    {
        code: 'it_IT',
        label: "Italiano (Italia)"
    },
    {
        code: 'pt_PT',
        label: "Português (Portugal)"
    },
    {
        code: 'nl_NL',
        label: "Nederlands (Nederland)"
    },
    {
        code: 'ru_RU',
        label: "Pусский (Россия)"
    },
    {
        code: 'zh_CN',
        label: "中文 (中华人民共和国)",
    },
    {
        code: 'pl_PL',
        label: "Polski (Polska)",
    },
    /*{
        code: 'de_AT',
        label: "Deutsch (Österreich)"
    },
    {
        code: 'hi_IN',
        label: "हिन्दी (इंडिया)"
    },
    {
        code: 'pl_PL',
        label: "Polski (Polska)"
    },
    {
        code: 'th_TH',
        label: "ไทย (ไทย)"
    },
    {
        code: 'ms_MY',
        label: "Bahasa Melayu (Malaysia)"
    },
    {
        code: 'vi_VN',
        label: "Tiểng Việt (Việt Nam)"
    },
    {
        code: 'sk_SK',
        label: "Slovenčina (Slovenská republika)"
    },
    {
        code: 'fi_FI',
        label: "Suomi (Suomi)"
    },
    {
        code: 'da_DK',
        label: "Dansk (Danmark)"
    },
    {
        code: 'et_EE',
        label: "Eesti (Eesti)"
    },
    {
        code: 'no_NO',
        label: "Bokmål (Norge)"
    },
    {
        code: 'sl_SI',
        label: "Slovenski (Slovenija)"
    },
    {
        code: 'ro_RO',
        label: "Română (România)"
    },
    {
        code: 'lv_LV',
        label: "Latviešu (Latvija)"
    },
    {
        code: 'bg_BG',
        label: "български (България)"
    },
    {
        code: 'sv_SE',
        label: "Svenska (Sverige)"
    },
    {
        code: 'tr_TR',
        label: "Türkçe (Türkiye)"
    },
    {
        code: 'cs_CZ',
        label: "Čeština (Česká republika)"
    },
    {
        code: 'hu_HU',
        label: "Magyar (Magyarország)"
    },
    {
        code: 'lt_LT',
        label: "Lietuvių (Lietuva)"
    },
    {
        code: 'ja_JP',
        label: "日本語 (日本)"
    },
    {
        code: 'ko_KR',
        label: "한국어 (대한민국)"
    },
    {
        code: 'zh_CN',
        label: "中文 (中华人民共和国)"
    },
    {
        code: 'ar_AE',
        label: "(سعودي) العربية"
    },
    {
        code: 'fa_IR',
        label: "ﻰﺴﺮﺎﻓ"+" (Iran)"
    },
    {
        code: 'sr_RS',
        label: "Srpski (Србија)"
    },*/
]